import { AbstractControl } from '@angular/forms';

export class FormHelper {
    public static isEmptyControl(control: AbstractControl): boolean {
        return (
            !!control &&
            (control.value === '' || control.value === null || typeof control.value === 'undefined')
        );
    }
}
